import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { API } from "@/lib/site";
import { setToken, formatApiError } from "@/lib/admin";

const inputCls = "w-full border border-line bg-white px-4 py-3.5 text-sm text-ink outline-none placeholder:text-neutral-600 focus:border-regal-amber transition-colors";

export default function AdminLogin() {
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await axios.post(`${API}/auth/login`, form);
      setToken(data.token);
      nav("/admin");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="grid min-h-[80vh] place-items-center bg-surface px-5 pt-24 pb-16" data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-sm border border-line bg-white p-8 shadow-[0_16px_40px_rgba(16,24,40,0.08)]" data-testid="admin-login-form">
        <img src="/assets/logo/emblem.png" alt="Regal Tuning" className="mx-auto h-14 w-auto" />
        <h1 className="mt-5 text-center font-display text-xl font-bold uppercase tracking-wide text-ink">Product Manager</h1>
        <p className="mt-1 mb-7 text-center font-mono text-[11px] uppercase tracking-[0.2em] text-neutral-500">Admin access only</p>
        {error && <p className="mb-4 border border-regal-red/40 bg-regal-red/5 px-4 py-3 text-sm text-regal-red" data-testid="admin-login-error">{error}</p>}
        <label className="mb-4 block">
          <span className="mb-1.5 block font-mono text-[11px] uppercase tracking-[0.2em] text-neutral-500">Email</span>
          <input type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className={inputCls} data-testid="admin-email-input" />
        </label>
        <label className="mb-6 block">
          <span className="mb-1.5 block font-mono text-[11px] uppercase tracking-[0.2em] text-neutral-500">Password</span>
          <input type="password" required value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className={inputCls} data-testid="admin-password-input" />
        </label>
        <button type="submit" disabled={busy} data-testid="admin-login-submit" className="w-full bg-regal-amber py-4 font-display text-sm font-bold uppercase tracking-[0.16em] text-white hover:bg-amber-400 transition-colors disabled:opacity-60">
          {busy ? "Signing in…" : "Sign In"}
        </button>
        <Link to="/" className="mt-5 block text-center text-xs text-neutral-500 hover:text-regal-amber" data-testid="admin-back-to-site">← Back to website</Link>
      </form>
    </main>
  );
}
